module.exports = __webpack_public_path__ + "img/logo.255851de.webp";